export const penaltyTypes: TableModule = {
    name: "penaltyTypes",
    route: "spa.basicData.penaltyTypes",
    defaultOrder: {
        column: "id",
        direction: "desc"
    },
    columns: [
        {
            name: "name",
            sortable: true,
            pageLink: true,
            mobile: true,
        }, {
            name: "sport_name",
            mobile: true,
            width: 'w-[120px]',
        }, {
            name: "type",
            breakpoint: "md",
            width: 'w-[120px]',
        }, {
            name: "price",
            width: 'w-[90px]',
        }, {
            name: "active",
            width: 'w-[75px]',
        }
    ],
    filters: [
        {
            name: "sport",
            column: "sport_id",
            type: "select",
            reduced: 'in',
            options: () => $lara.get(
                useNuxtApp().$apiRoute('spa.basicData.sportSelect.index')
            ).then(response => response.data?.map(
                (sport: { id: number, name: string }) => ({
                    value: sport.id,
                    label: sport.name
                }))
            ),
            ability: ['viewAny', 'sports']
        }
    ],
    quickFilters: [
        {
            name: "qfActiveOnly",
            column: "active",
            operator: "=",
            value: true,
            default: true
        }
    ],
    tools: [
        {
            isCreateAction: true,
            ability: ["create", "penaltyTypes"]
        }
    ]
}